import { LazyPage } from '../components-ui/loadable';

export const DanhSachThiSinhLopPage = LazyPage(
    import('./xet-tuyen-thac-sy/danh-sach-thi-sinh-lop/DanhSachThiSinhLopPage')
);
export const DanhSachThiSinhPage = LazyPage(import('./xet-tuyen-thac-sy/ho-so-thi-sinh-dang-ky/DanhSachThiSinhPage'));
export const DongTuiLapPhachPage = LazyPage(import('./xet-tuyen-thac-sy/dong-tui-lap-phach/DongTuiLapPhachPage'));
export const DotTuyenSinhPage = LazyPage(import('./xet-tuyen-thac-sy/dot-tuyen-sinh/DotTuyenSinhPage'));
export const GanMonHocPage = LazyPage(import('./xet-tuyen-thac-sy/gan-mon-hoc/GanMonHocPage'));
export const LopHocPage = LazyPage(import('./xet-tuyen-thac-sy/lop-hoc/LopHocPage'));
export const NhapDiemTheoLopPage = LazyPage(import('./xet-tuyen-thac-sy/nhap-diem-theo-lop/NhapDiemTheoLopPage'));
export const NganhTuyenSinhPage = LazyPage(import('./xet-tuyen-thac-sy/thiet-lap-nganh-tuyen-sinh/NganhTuyenSinhPage'));
export const ToChucThiPhongPage = LazyPage(import('./xet-tuyen-thac-sy/to-chuc-thi-phong/ToChucThiPhongPage'));
export const XepThoiKhoaBieuPage = LazyPage(import('./xet-tuyen-thac-sy/xep-thoi-khoa-bieu/XepThoiKhoaBieuPage'));
export const NhapDiemTheoTuiPage = LazyPage(import('./xet-tuyen-thac-sy/nhap-diem-theo-tui/NhapDiemTheoTuiPage'));
export const ThongKeThiSinhBSKTPage = LazyPage(
    import('./xet-tuyen-thac-sy/thong-ke-thi-sinh-dang-ky/ThongKeBSKTPage')
);
export const ThongKeHocVienBSKTPage = LazyPage(
    import('./xet-tuyen-thac-sy/thong-ke-thi-sinh-dang-ky/ThongKeBSKTPage')
);
export const TongHopDiemPage = LazyPage(import('./xet-tuyen-thac-sy/tong-hop-diem/TongHopDiemPage'));
